import React from 'react';
import { HOVER_EFFECT_OPTIONS } from '../utils/mediaHoverEffects';
import { inputClass } from './BackgroundFields';

function Field({ label, children }) {
  return (
    <label className="block space-y-1.5">
      <span className="text-xs font-medium text-muted-foreground">{label}</span>
      {children}
    </label>
  );
}

export default function HoverEffectFields({
  props,
  setProp,
  prefix,
  title = 'Effets au survol',
  hint = 'Au passage de la souris sur le bloc publié.',
}) {
  const effectKey = `${prefix}HoverEffect`;
  const intensityKey = `${prefix}HoverIntensity`;
  const effect = props?.[effectKey] || 'none';
  const intensity = props?.[intensityKey] ?? 65;

  return (
    <div className="rounded-lg border border-border p-3 space-y-3 bg-muted/10">
      <p className="text-xs font-semibold text-foreground">{title}</p>
      <Field label="Effet">
        <select
          className={inputClass}
          value={effect}
          onChange={(e) => setProp(effectKey, e.target.value)}
        >
          {HOVER_EFFECT_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </Field>
      {effect !== 'none' ? (
        <Field label="Intensité">
          <input
            type="range"
            min={10}
            max={100}
            step={5}
            className="w-full"
            value={intensity}
            onChange={(e) => setProp(intensityKey, Number(e.target.value))}
          />
        </Field>
      ) : (
        <p className="text-xs text-muted-foreground leading-relaxed">{hint}</p>
      )}
    </div>
  );
}
